export const toWhatsAppNumber = (raw: string): string | null => {
  const digits = raw.replace(/[\s\-().]/g, '').replace(/^\+/, '');
  if (!digits) return null;
  if (digits.startsWith('62')) return digits;
  if (digits.startsWith('0')) return `62${digits.slice(1)}`;
  return `62${digits}`;
};
